import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Image } from 'containers/misc'
import { getFullName, multipleOrganizations } from 'utils/token'
import styles from './user-menu.styl'
import { ROLES } from '../../../constants/enums'

@connect(({ api, auth }) => ({
  user: auth.user,
  role: get(auth, 'organization.role'),
  profile: api.dashboard.persons.profile
}))

class UserMenu extends Component {
  static propTypes = {
    actions: PropTypes.array.isRequired,
    user: PropTypes.object,
    role: PropTypes.string,
    profile: PropTypes.object
  }

  constructor(props) {
    super(props)

    this.name = getFullName(props.user)
    this.organization = get(props, 'user.organizationName')
    this.multipleOrganizations = multipleOrganizations(props.user)

    this.state = {
      open: false
    }
  }

  handleToggle = () => this.setState({ open: !this.state.open })

  handleItemClick = () => this.setState({ open: false })

  handleClickOutside = () => this.setState({ open: false })

  handleOnClick = onClick => {
    onClick()
    this.handleItemClick()
  }

  render() {
    const { actions, profile, role } = this.props
    const { open } = this.state

    return (
      <div className={styles.dropdown}>
        <button className={styles.actionMain} onClick={this.handleToggle}>
          <div className={styles.avatar}>
            {get(profile, 'data.photoUrl') && (
              <Image
                src={get(profile, 'data.photoUrl')}
                alt="Profile picture"
                width={30}
                height={30}
              />
            )}

            {!get(profile, 'data.photoUrl') && (
              <span className={`ico ico--user ${styles.icoCustom} `} />
            )}
          </div>
          <span className={styles.name}>{this.name}</span>
          {ROLES.ASSESSOR.u !== role && <span className={styles.organization}>{this.organization}</span>}

          <span className={`ico ico--chevron-down ${styles.icoList}`} />
        </button>
        {open && (
          <ul className={styles.list}>
            {actions.map((item, index) => (
              <li key={index} className={styles.item}>
                {item.onClick ? (
                  <a
                    className={styles.link}
                    onClick={() => this.handleOnClick(item.onClick)}
                  >
                    {item.intlKey ? (
                      <FormattedMessage
                        id={item.intlKey}
                        defaultMessage={item.label}
                      />
                    ) : (
                      item.label
                    )}
                  </a>
                ) : (
                  <Link
                    to={item.action}
                    className={styles.link}
                    onClick={this.handleItemClick}
                  >
                    {item.intlKey ? (
                      <FormattedMessage
                        id={item.intlKey}
                        defaultMessage={item.label}
                      />
                    ) : (
                      item.label
                    )}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    )
  }
}

export default UserMenu
